module.exports = __webpack_public_path__ + "img/97.2286a47.png";